import { css } from '@linaria/core';
import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria. Не критично, при необходимости стилизовать дочерений <a> вместо Link
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

import { MqTablet } from '~theme/media';

export const Container = styled.div`
	position: fixed;
	z-index: 2;
	right: 16px;
	bottom: 0;
	left: 0;
	display: flex;

	width: 100%;
	justify-content: space-around;
	padding: 2px 12px calc(2px + var(--safe-bottom));
	border-top: 1px var(--color-grey-19-solid) solid;
	margin: 0 auto;
	background: var(--color-grey-6-solid);

	${MqTablet} {
		display: none;
	}
`;

export const TabLink = styled(Link)<{ active: 0 | 1; order?: number }>`
	--active: ${({ active = 0 }) => (active ? 'var(--color-error)' : 'inherit')};
	position: relative;
	display: flex;
	flex-basis: 0;
	flex-direction: column;
	flex-grow: 1;
	align-items: center;
	justify-content: center;
	order: ${({ order = 0 }) => order};
	padding-top: 6px;
	padding-bottom: 6px;
	color: ${({ active = 0 }) =>
		active ? 'var(--color-grey-95-solid)' : 'var(--color-grey-68-solid)'};
	gap: var(--gap-m);
	pointer-events: ${({ active = 0 }) => (active ? 'none' : 'auto')};

	& > *:first-child {
		width: 2rem;
		height: 2rem;
	}
`;

export const unreadMessagesClass = css`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(0, calc(-50% - 1.9rem));
`;
